// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b4fca4a0","455":"ef263d05","977":"90521065"}[chunkId] + ".chunk.js";
};